module.exports = __webpack_public_path__ + "media/fonts/Oricons-6c91e3d3dacd51a595af23be4c7d168e.eot";